<template>
  <div id="app">
      <router-view/>
  </div>
</template>

<script>
  import SideBar from "@/views/sideBar/index";
export default {
  name: 'App',
    components:{
        SideBar
    },
    data () {
        return {
            isCollapsed: false
        }
    },
    computed: {

    },
    methods:{

    }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;*/
  color: #2c3e50;
    /*overflow: scroll;*/
    /*-webkit-overflow-scrolling: touch;*/
}
</style>



// WEBPACK FOOTER //
// src/App.vue